import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  telFixe = "0327655417";
  telPortable = "0698365417";

  displayModalML = false;
  displayModalPDC = false;
  displayModalCookies = false;


  @Input()
  isMobile: Boolean

  constructor() { }

  ngOnInit(): void {
  }

}
